var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"overflow-x":"hidden","overflow-y":"hidden","padding-right":"0px","padding-left":"0px"},attrs:{"id":"app"}},[_c('nav-bar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }